/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取设备卡库列表
export function listWriteCard(params) {
    return request({
        url: 'writeCardInfo/list.do?',
        method: 'post',
        data: params
    })
}

// 导出设备卡库
export function exportWriteCardSync(params) {
    return request({
        url: 'writeCardInfo/export.do?',
        method: 'post',
        data: params
    })
}

// 根据ID删除设备卡库
export function deleteById(params) {
    return request({
        url: 'writeCardInfo/delete.do?',
        method: 'post',
        data: params
    })
}

// 批量导入设备卡库
export function importExcel(params) {
    return request({
        url: 'writeCardInfo/batchImportSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 批量删除设备卡库
export function batchDelete(params) {
    return request({
        url: 'writeCardInfo/batchDelete.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 写卡接口（模拟）
export function writeCard(params) {
    return request({
        url: 'writeCardInfo/processCardInfo.do?',
        method: 'post',
        data: params
    })
}

// 编辑卡接口（模拟）
export function editCard(params) {
    return request({
        url: 'writeCardInfo/update.do?',
        method: 'post',
        data: params
    })
}

// 批量更新imei
export function batchUpdateImei(params) {
    return request({
        url: 'writeCardInfo/batchUpdateImei.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}
